import { render, staticRenderFns } from "./sowhatbuy-card-basic.vue?vue&type=template&id=39053395&scoped=true&"
import script from "./sowhatbuy-card-basic.vue?vue&type=script&lang=js&"
export * from "./sowhatbuy-card-basic.vue?vue&type=script&lang=js&"
import style0 from "./sowhatbuy-card-basic.vue?vue&type=style&index=0&id=39053395&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39053395",
  null
  
)

export default component.exports